// Layout: Browse Talent Group
// 

JLM.MD.TalentBrowseGroup = function( container, division_type, data_talent ) {
	
	const INSTANCE = new JLM.MD.Module();
	
	
	// Constants: Private _______________________________________________________
	
	const VIEWPORT_MARGIN = 300; // Margin to start loading
	
	
	
	// Variables: Private _______________________________________________________
	
	// References
	let group_header_tally, group_wrap, talent_list;
	
	// Settings
	let talent_entries = [],
		talent_entries_by_id = {},
		talent_matches = data_talent.length,
		area_top = 0,
		area_width = 0,
		profile_width = 0,
		profile_height = 0;
	
	
	
	// Variables: Public ________________________________________________________
	
	INSTANCE.is_open = true;
	
	
	
	// Constructor ______________________________________________________________
	
	function init() {
		var group_header, group_header_link;
		
		// Set references
		group_header = $('h2', container);
		group_header_link = $('> span', group_header);
		group_header_tally = $('.tally', group_header_link);
		group_wrap = $('.subwrap', container);
		talent_list = $('ul.directory', group_wrap);
		
		// Fetch existing items from DOM
		$('> li', talent_list).each(function(index) {
			let item = $(this),
				talent_id = parseInt( item.attr('data-id') );
			createEntry( item, talent_id, true );
		});
		
		// Create extra items
		data_talent.forEach(function( data_item ) {
			let talent_id = data_item.ID;
			if ( !talent_entries_by_id[ talent_id ] ) {
				createEntry( data_item, data_item.ID );
			}
		});
		
		// Events
		group_header_link.on('click', toggle);
		$(window).on('resize', INSTANCE.recalculate).on('scroll', redraw);
		
		// Setup positions and draw
		INSTANCE.recalculate();
	}
	
	
	
	// Methods: Private _________________________________________________________
	
	// Event: Toggle area open/closed
	// 
	function toggle() {
		// Hide / Show area
		if ( INSTANCE.is_open ) {
			container.attr('data-status', 'closed');
			INSTANCE.is_open = false;
		} else {
			container.attr('data-status', 'open');
			INSTANCE.is_open = true;
		}
		
		// Announce change
		INSTANCE.dispatchEvent('toggle');
	}
	
	
	// Draw items on screen
	// 
	function redraw() {
		if ( INSTANCE.is_open ) {
			// Get viewport position and item size
			let viewport_height = $(window).height(),
				viewport_top = $(window).scrollTop();
			
			// Check if each item is on screen or not
			talent_entries.forEach(function( entry ) {
				if (( entry.boundaries.top < ( viewport_height + viewport_top + VIEWPORT_MARGIN )) && ( entry.boundaries.bottom > ( viewport_top - VIEWPORT_MARGIN ))) {
					entry.setOnScreen( true );
				} else {
					entry.setOnScreen( false );
				}
			});
		}
	}
	
	
	// Create a talent entry
	// 
	function createEntry( item_or_data, talent_id, auto_load ) {
		// Create entry
		const entry = new JLM.MD.TalentBrowseEntry( division_type, talent_list, talent_id, item_or_data );
			if ( auto_load ) entry.load();
		talent_entries.push( entry );
		talent_entries_by_id[ talent_id ] = entry;
		
		// Events
		entry.on('shortlist_remove', function() {
			INSTANCE.dispatchEvent('shortlist_remove', [ talent_id, division_type ]);
		});
		entry.on('shortlist_add', function() {
			INSTANCE.dispatchEvent('shortlist_add', [ talent_id, division_type ]);
		});
	}
	
	
	
	// Methods: Public __________________________________________________________
	
	// Recalculate positions/sizes
	// 
	INSTANCE.recalculate = function() {
		if ( INSTANCE.is_open ) {
			// Get list dimensions
			area_top = talent_list.offset().top;
			area_width = talent_list.width();
			if ( talent_entries.length ) {
				profile_width = talent_entries[0].item.outerWidth();
				profile_height = talent_entries[0].item.outerHeight();
			}
			
			// Calculations
			let per_row = Math.floor( area_width / profile_width ),
				total_rows = Math.ceil( talent_matches / per_row ),
				area_height = Math.round( total_rows * profile_height );
			
			// Update area height
			group_wrap.css('min-height', area_height);
			
			// Update each item dimension
			let index = 0;
			talent_entries.forEach(function( entry ) {
				if ( entry.is_match ) {
					let top = area_top + ( Math.floor( index / per_row ) * profile_height ),
						bottom = top + profile_height;
					entry.setBoundaries( top, bottom );
					index++;
				}
			});
			
			// Check position
			redraw();
		}
	};
	
	
	// Remove entries from Shortlist
	// 
	INSTANCE.removeFromShortlist = function( talent_id, division_type ) {
		if ( talent_entries_by_id[ talent_id ] ) {
			talent_entries_by_id[ talent_id ].removeFromShortlist();
		}
	};
	INSTANCE.emptyShortlist = function() {
		talent_entries.forEach(function( entry ) {
			entry.removeFromShortlist();
		});
	};
	
	
	// Draw items on screen
	// 
	INSTANCE.filter = function( data_match, name_search ) {
		var num_matches = 0;
		
		// Set [matched] or not
		talent_entries.forEach(function( entry ) {
			if ( data_match[ entry.id ] ) {
				entry.setIsMatch( true, name_search );
				num_matches++;
			} else {
				entry.setIsMatch( false );
			}
		});
		
		// Update tally
		talent_matches = num_matches;
		container.attr('data-matches', num_matches);
		
		// Calculate position etc
		INSTANCE.recalculate();
		
		// Update header
		group_header_tally.text( num_matches );
		
		return num_matches;
	};
	
	
	// Initial Setup ____________________________________________________________
	
	init();
	return INSTANCE;
	
};